// extracted by mini-css-extract-plugin
export default {"card":"hY-z"};